var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJava(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    enableBackground: "new 0 0 64 64",
    height: 128,
    viewBox: "0 0 64 64",
    width: 128,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m42 2h-32v8h-8v48h40z",
    fill: "#b9c0c9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m42 6v52h-36v4h40v-56z",
    fill: "#8b9097"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m18 14h44v20h-44z",
    fill: "#b9a261"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m18 14h41v20h-41z",
    fill: "#f7d881"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m10 2-8 8h8z",
    fill: "#8b9097"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m42 59h-40c-.552 0-1-.447-1-1v-48c0-.553.448-1 1-1h7v-7c0-.553.448-1 1-1h32c.552 0 1 .447 1 1v12h-2v-11h-30v7c0 .553-.448 1-1 1h-7v46h38v-23h2v24c0 .553-.448 1-1 1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m.343 5h11.314v2h-11.314z",
    transform: "matrix(.707 -.707 .707 .707 -2.485 6)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m46 63h-40c-.552 0-1-.447-1-1v-4h2v3h38v-27h2v28c0 .553-.448 1-1 1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m47 14h-2v-7h-3v-2h4c.552 0 1 .447 1 1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m62 35h-44c-.552 0-1-.447-1-1v-20c0-.553.448-1 1-1h44c.552 0 1 .447 1 1v20c0 .553-.448 1-1 1zm-43-2h42v-18h-42z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m5 13h10v2h-10z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m5 17h10v2h-10z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m5 21h10v2h-10z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m5 25h10v2h-10z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m5 29h10v2h-10z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m13 5h26v2h-26z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m13 9h26v2h-26z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m14 55h-3c-1.654 0-3-1.346-3-3v-2.586l-2.707-2.707c-.391-.391-.391-1.023 0-1.414l2.707-2.707v-2.586c0-1.654 1.346-3 3-3h3v2h-3c-.551 0-1 .448-1 1v3c0 .266-.105.52-.293.707l-2.293 2.293 2.293 2.293c.188.187.293.441.293.707v3c0 .552.449 1 1 1h3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m33 55h-3v-2h3c.551 0 1-.448 1-1v-3c0-.266.105-.52.293-.707l2.293-2.293-2.293-2.293c-.188-.187-.293-.441-.293-.707v-3c0-.552-.449-1-1-1h-3v-2h3c1.654 0 3 1.346 3 3v2.586l2.707 2.707c.391.391.391 1.023 0 1.414l-2.707 2.707v2.586c0 1.654-1.346 3-3 3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m23 17h6v2h-6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m24 31c-1.654 0-3-1.346-3-3v-2h2v2c0 .552.449 1 1 1s1-.448 1-1v-10h2v10c0 1.654-1.346 3-3 3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m39 31h-2v-10c0-1.103-.897-2-2-2s-2 .897-2 2v10h-2v-10c0-2.206 1.794-4 4-4s4 1.794 4 4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m32 25h6v2h-6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m59 31h-2v-10c0-1.103-.897-2-2-2s-2 .897-2 2v10h-2v-10c0-2.206 1.794-4 4-4s4 1.794 4 4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m52 25h6v2h-6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m45 31c-.256 0-.512-.098-.707-.293l-3-3c-.188-.187-.293-.441-.293-.707v-10h2v9.586l2 2 2-2v-9.586h2v10c0 .266-.105.52-.293.707l-3 3c-.195.195-.451.293-.707.293z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m14.384 45h15.232v1.999h-15.232z",
    transform: "matrix(.394 -.919 .919 .394 -28.946 48.114)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m16.293 50.707-4-4c-.391-.391-.391-1.023 0-1.414l4-4 1.414 1.414-3.293 3.293 3.293 3.293z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m27.707 50.707-1.414-1.414 3.293-3.293-3.293-3.293 1.414-1.414 4 4c.391.391.391 1.023 0 1.414z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJava);
export default __webpack_public_path__ + "static/media/java.a074c0b40502d6ed546b12872c5a6373.svg";
export { ForwardRef as ReactComponent };